import * as firebase from 'firebase/app'
import 'firebase/firestore';
import 'firebase/auth'
import 'firebase/storage'

// Your web app's Firebase configuration
const firebaseConfig = {
apiKey: "AIzaSyA6XtFiwR5yhx6DoWpXD80CVe1WUBYJphI",
authDomain: "my-recipes-25c03.firebaseapp.com",
databaseURL: "https://my-recipes-25c03.firebaseio.com",
projectId: "my-recipes-25c03",
storageBucket: "my-recipes-25c03.appspot.com",
messagingSenderId: "436876407246",
appId: "1:436876407246:web:e9b8729f5414fb41363b9f",
measurementId: "G-RVJSMT10HE"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig)
export const auth = app.auth();
export const firestore = app.firestore();
export const storage = app.storage();

export const timestamp = firebase.firestore.FieldValue.serverTimestamp;